import { ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import { CustomerForecastTimelineFilterItem } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';

/**
 * 客先内示のフィルタ用アダプタ
 */
export class CustomerForecastFilterItemsAdapter {
  /**
   * 選択肢のアダプタ
   * @param item - 選択肢のアイテム
   */
  public static adapt = (item?: ForecastTimelineFilterProperty): CustomerForecastTimelineFilterItem | undefined => {
    let baseBusinessResponsibleUserId = item?.staffName;
    if (baseBusinessResponsibleUserId) {
      baseBusinessResponsibleUserId = baseBusinessResponsibleUserId.split(',')[1];
    }
    return item
      ? {
          baseBusinessResponsibleUserId: baseBusinessResponsibleUserId,
          warehouseNumber: item.warehouseCode,
          warehouse: item.warehouse,
          supplierNumber: item.supplierCode,
          supplierName: item.supplierName,
          businessNumber: item.businessCode,
          businessName: item.businessName,
          package: item.packageAmount,
          customerNumber: item.customerCode,
          customerName: item.customerName,
          salesDestinationNumber: item.salesDestinationCode,
          salesDestinationName: item.salesDestinationName,
        }
      : undefined;
  };
}
